// extracted by mini-css-extract-plugin
export default {"logosWrapper":"styles_logosWrapper__Fn+Hr","title":"styles_title__mO8TL","logos":"styles_logos__pjRMM"};